import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable()
export class DevisService {
  private baseUrl = `${environment.API_URL}/devis`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient) {}

  createDevis(devisData: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/create`, devisData, { headers: this.headers });
  }
  updateDevis(devisId: number, devisData: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/update/${devisId}`, devisData, { headers: this.headers });
  }


  getDevis(params: any): Observable<any> {
    return this.http.
      post(`${this.baseUrl}`, params, { headers: this.headers})
      .map((res) => JSON.parse(JSON.stringify(res)));
  }
  createDemande(devisData: any) {
    return this.http.post<any>(`${this.baseUrl}/demand/create`, devisData, { headers: this.headers })
    .map((res) => JSON.parse(JSON.stringify(res)));
  }

  answerDevis(devisId: number, formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/${devisId}/answer`, formData, { headers: this.headers })
    .map((res) => JSON.parse(JSON.stringify(res)));
  }

  getDevisById(devisId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${devisId}`, { headers: this.headers })
    .map((res) => JSON.parse(JSON.stringify(res)));
  }
  
  getApiURI() {
    return environment.API_URL;
  }

  download(file) {
    return this.http.get(`${environment.API_URL}/download/${file}`, { headers: this.headers, responseType: "blob" });
  }
  deleteDevisFile(devisId: number) {
    return this.http.put(`${this.baseUrl}/${devisId}/empty-devis-filename`, {}, { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/devis.service.ts